module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-14750.013 -9747.465 32.869 18.652","width":"32","height":"18"}},[_c('defs'),_c('g',{attrs:{"id":"continuar","transform":"translate(-15963 -11605)"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_47","data-name":"Path 47","d":"M1.4 23.407h30.041","transform":"rotate(180 622.214 945.134)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_48","data-name":"Path 48","d":"M9.312 23.024L1.4 15.112 9.312 7.2","transform":"rotate(180 622.214 940.986)"}})])])}}};


//////////////////
// WEBPACK FOOTER
// ./static/media/ico-continuar.svg
// module id = GOfw
// module chunks = 0